<template>
  <div class="panel-row" v-loading="loading">
    <div class="left_label">选择人群</div>
    <div class="weidu-cont">
      <div class="weidu-item">
        <t-select size="small" v-model="val" placeholder="请选择" @change="handleChange">
          <t-option v-for="(option, idx) in list" :key="idx" :label="option.label" :value="option.value"></t-option>
        </t-select>
      </div>
    </div>
  </div>
</template>

<script>
import { getPackageList } from '@/api/analysis/custom-analysis';

export default {
  name: 'people-group-select',
  data() {
    return {
      loading: false,
      val: '',
      list: [],
    };
  },
  props: {
    value: {
      type: [Number, String],
    },
  },
  created() {
    this.getFormOptions();
  },

  watch: {
    value(cur) {
      if (typeof cur === 'number') {
        this.val = cur;
      }
    },
  },

  methods: {
    getFormOptions() {
      this.loading = true;
      getPackageList({ params: { paged: 0, pageNo: 1, pageSize: 10000 } })
        .then(res => {
          const { list = [] } = res || {};
          const peopleCrowd = list.map(item => ({ label: item.packageName, value: item.id }));

          this.list = [
            {
              label: '总体',
              value: '',
            },
            ...peopleCrowd,
          ];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChange(...rest) {
      this.$emit('input', ...rest);
    },
  },
};
</script>

<style scoped lang="less">
.panel-row {
  display: flex;
  margin-top: 20px;

  .left_label {
    width: 100px;
    min-width: 100px;
    color: #888888;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }

  .weidu-cont {
    display: flex;
    align-items: center;
    flex: 1;
    &:hover {
      background-color: #fafafa;
    }

    .weidu-item {
      padding: 0 10px 0 10px;
      position: relative;

      &:first-child {
        padding-left: 0;
      }

      &:hover {
        background-color: rgb(234, 234, 234);

        .close {
          display: block;
        }
      }
    }
  }
}
</style>
